document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.section-traffic')
  if (section) {
    const itemList = section.querySelectorAll('.section-traffic__item')
    itemList.forEach((item) => {
      const soundAnimation = item.querySelector('.section-traffic__sound-icon')
      const soundBox = item.querySelector('.section-traffic__sound-box')
      const sound = new Audio(item.dataset.sound)
      sound.loop = true
      if (soundAnimation) {
        const animation = lottie.loadAnimation({
          container: soundAnimation,
          renderer: 'svg',
          loop: true,
          autoplay: false,
          path: 'images/section-traffic/sound-animation.json'
        })

        const toggle = () => {
          if (soundBox.classList.contains('section-traffic__sound-box--active')) {
            stop()
          }
          else {
            play()
          }
        }

        const stop = () => {
          soundBox.classList.remove('section-traffic__sound-box--active')
          animation.stop()
          sound.pause()
          sound.currentTime = 0
        }

        const play = () => {
          soundBox.classList.add('section-traffic__sound-box--active')
          sound.play()
          animation.play()
        }

        soundBox.addEventListener('click', toggle)
        document.addEventListener('click', (e) => {
          if(!e.target.closest('.section-traffic__item') || e.target.closest('.section-traffic__item') !== item) {
            stop()
          }
        })

        window.addEventListener('scroll', () => {
          stop()
        })
      }
    })
    
    const content = document.querySelector('.section-traffic__content')
    const cards = document.querySelectorAll(".section-traffic__item");
    let mm = gsap.matchMedia()
    mm.add("(max-width: 1023px)", () => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: content,
          start: "top 100px",
          end: `+=${content.offsetHeight}`,
          scrub: 1.3,
          markers: false,
          pin: true,
          pinSpacer: false
        },
      })

      tl.to(cards[0], { scale: 0.8, opacity: .8, duration: .9 });
      tl.to(cards[1], { y: `-=${.98 * cards[1].offsetHeight}`, duration: 1 }, '-=.65');
      tl.to(cards[1], { scale: 0.9, opacity: .9, duration: 1 }, '-=.35');
      tl.to(cards[2], { y: `-=${1.88 * cards[2].offsetHeight}`, duration: 1 }, '-=.65');
      tl.to('.section-system', { marginTop: `-=${cards[0].offsetHeight + cards[1].offsetHeight}`, duration: 1 }, '-=.5')
    })
  }
})